import { styled } from '@mui/material/styles';

interface DividerProps {
    height: number;
}

export const StyledDivider = styled('div')<DividerProps>(({ height }) => ({
    backgroundColor: "#b4b6c5",
    width: "100%",
    height: `${height}px`
})); 